<template>
  <div class="flex flex-col items-center justify-center py-13">
    <icon-base :icon="IconNotFound" height="70" width="70" />
    <lf-h4 class="mt-4">{{ title }}</lf-h4>
    <div class="mt-2 flex flex-col items-center justify-center lg:w-125">
      <span v-if="showFirstExplanation" class="text-center">
        {{ $t("DEALS.DEAL_PROGRESS.NO_BUSINESS_FOUND_EXPL_1") }}
      </span>
      <span class="text-center">
        {{ $t("DEALS.DEAL_PROGRESS.NO_BUSINESS_FOUND_EXPL_2") }}
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconNotFound from "@/components/icons/IconNotFound.vue";

defineProps({
  title: {
    type: String,
    default: "",
  },
  showFirstExplanation: {
    type: Boolean,
    default: true,
  },
});
</script>
